"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-env browser */
const AleaRandomGenerator_1 = __importDefault(require("./AleaRandomGenerator"));
// instantiate RNG.  Heuristically collect entropy from various sources when a
// cryptographic PRNG isn't available.
// client sources
const height = (typeof window !== 'undefined' && window.innerHeight) ||
    (typeof document !== 'undefined' &&
        document.documentElement &&
        document.documentElement.clientHeight) ||
    (typeof document !== 'undefined' &&
        document.body &&
        document.body.clientHeight) ||
    1;
const width = (typeof window !== 'undefined' && window.innerWidth) ||
    (typeof document !== 'undefined' &&
        document.documentElement &&
        document.documentElement.clientWidth) ||
    (typeof document !== 'undefined' &&
        document.body &&
        document.body.clientWidth) ||
    1;
const agent = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
function createAleaGenerator() {
    return new AleaRandomGenerator_1.default({
        seeds: [new Date(), height, width, agent, Math.random()],
    });
}
exports.default = createAleaGenerator;
